export const getBakeMuskMixerCommonStakeERC721EarnBakeAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake && sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake.options.address
}

export const getBakeMuskMixerCommonStakeERC721EarnBakeContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixerCommonStakeERC721EarnBake
}

export const getBakeMuskMixerAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixer && sushi.contracts.bakeMuskMixer.options.address
}

export const getBakeMuskMixerContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.bakeMuskMixer
}

export const getWaitingToMintLength = async bakeMuskMixer => {
  return bakeMuskMixer.methods.getWaitingToMintLength().call()
}

export const mint = async (bakeMuskMixer, payToken, payAmount, account) => {
  return bakeMuskMixer.methods
    .mint(payToken, payAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

export const mintByBNB = async (bakeMuskMixer, payAmount, account) => {
  return bakeMuskMixer.methods
    .mint('0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', payAmount)
    .send({ from: account, value: payAmount })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}


export const lucky = async (bakeMuskMixer, luckyToken, payAmount, account) => {
  return bakeMuskMixer.methods
    .lucky(luckyToken, payAmount)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}


export const luckyByBNB = async (bakeMuskMixer, payAmount, account) => {
  return bakeMuskMixer.methods
    .lucky('0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', payAmount)
    .send({ from: account, value: payAmount })
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}


export const getPayTokenInfos = async (bakeMuskMixer, payTokens) => {
  return bakeMuskMixer.methods.getPayTokenInfos(payTokens).call()
}

export const getLockTokenInfos = async (bakeMuskMixer, luckTokens) => {
  return bakeMuskMixer.methods.getLockTokenInfos(luckTokens).call()
}

/**
 * 获取当前用户参与抽奖的次数， 默认0次
 * @param bakeMuskMixer
 * @param account
 * @returns {Promise<*>}
 */
export const userLuckyTime = async (bakeMuskMixer, account) => {
  return bakeMuskMixer.methods.userLuckyTimes(account).call()
}

/**
 * 获取用户抽奖结果， 默认0 未抽奖。 1 成功， 2 失败
 * @param bakeMuskMixer
 * @param account
 * @param luckyTimes 第几次抽， 1...
 * @returns {Promise<*>}
 */
export const userLuckyResult = async (bakeMuskMixer, account, luckyTimes) => {
  return bakeMuskMixer.methods.userLuckyResults(account, luckyTimes).call()
}
